import * as React from 'react';

export const AddIcon = () => {
    return (
        <svg fill='#4569a0' viewBox='0 0 100 100' aria-hidden='true'>
            <path d='M44 12v32H12v12h32v32h12V56h32V44H56V12z'/>
        </svg>
    );
};
